import { Button } from '@monash/portal-react';
import CategoriesInputCard from './categories-input-card/CategoriesInputCard';
import c from './categories.module.scss';
import { useFieldArray } from 'react-hook-form';

const EMPTY_CATEGORY_DATA = {
  id: '',
  pinned: false,
  weight: 0,
  subcategories: [],
};

const Categories = ({ disabled }) => {
  const {
    fields: categories,
    append: appendCategory,
    remove: removeCategory,
  } = useFieldArray({
    name: 'categories',
  });

  return (
    <div className={c.categoriesContainer}>
      {categories.map((categoryData, i) => {
        return (
          <CategoriesInputCard
            key={categoryData.id}
            index={i}
            deleteCategoryData={() => removeCategory(i)}
            disabled={disabled}
          />
        );
      })}
      <Button
        variant="text"
        size="small"
        onClick={() => appendCategory(EMPTY_CATEGORY_DATA)}
        className={c.addButton}
        disabled={disabled}
      >
        Add category
      </Button>
    </div>
  );
};

export default Categories;
